// components/ControleBlock.jsx
import React from 'react';
import './ProjectBlock.css';

const ControleBlock = () => {
  const interventions = [
    "Élaboration et suivi des plannings (MS Project, Primavera)",
    "Mise en place d'indicateurs de performance (KPI)",
    "Suivi budgétaire et analyse des écarts",
    "Reporting projet (tableaux de bord, rapports d'avancement)",
    "Identification et gestion des risques",
    "Identification et gestion des interfaces",
    "Mise en place de système d'information de gestion de projet (PMIS)",
    "Contrôle documentaire"
  ];

  const results = [
    "Une visibilité fiable sur l'état des projets",
    "Une détection précoce des dérives",
    "Une meilleure maîtrise des coûts et délais",
    "Des décisions basées sur des données concrètes"
  ];

  return (
    <div className="project-block project-block-controle">
      <div className="project-block-header">
        <h1 className="section-title">3-Contrôle de projet</h1>
        <p className="section-subtitle">
        Pilotage et maîtrise de la performance des projets.
        <br/>
          Nous intervenons en contrôle de projet afin d'assurer une maîtrise rigoureuse des délais, 
          des coûts et des performances globales.
          Notre approche vise à fournir aux décideurs une visibilité claire et fiable sur l'avancement 
          des projets, tout en permettant d'anticiper les dérives et de sécuriser les résultats.
        </p>
      </div> 

      {/* Domaines d'intervention */}
      <div className="project-block-section project-block-section-interventions">
        <h2 className="project-block-section-title">Nos domaines d'interventions :</h2>
        <div className="project-block-list-container">
          <ul className="project-block-list">
            {interventions.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>

      {/* Résultats Attendus */}
      <div className="project-block-section project-block-section-results">
        <h3 className="project-block-section-title">Résultats attendus :</h3>
        <div className="project-block-list-container">
          <ul className="project-block-list">
            {results.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ControleBlock;